module.exports = __webpack_public_path__ + "img/Inform Graphic 3.b2d3d49f.png";